// POS 모듈 타입 정의

export interface POSItem {
  id: string;
  code: string;
  name: string;
  category: string;
  price: number;
  stock: number;
  unit: string;
  image?: string;
  barcode?: string;
  description?: string;
}

export interface POSCategory {
  id: string;
  name: string;
  icon?: string;
  itemCount: number;
}

export interface CartItem {
  item: POSItem;
  quantity: number;
  discount: number; // 할인율 (%)
  note?: string;
}

export interface Cart {
  items: CartItem[];
  subtotal: number;
  discount: number;
  tax: number;
  total: number;
}

export type PaymentMethod = 'cash' | 'card' | 'transfer' | 'mixed';

export interface Payment {
  method: PaymentMethod;
  amount: number;
  reference?: string; // 카드 승인번호, 계좌이체 참조번호 등
}

export interface POSOrder {
  id: string;
  orderNo: string;
  items: CartItem[];
  subtotal: number;
  discount: number;
  tax: number;
  total: number;
  payments: Payment[];
  paidAmount: number;
  change: number;
  status: POSOrderStatus;
  customer?: string;
  note?: string;
  createdAt: string;
  completedAt?: string;
}

export type POSOrderStatus = 'draft' | 'paid' | 'cancelled' | 'refunded';

export const ORDER_STATUS_LABELS: Record<POSOrderStatus, string> = {
  draft: '임시저장',
  paid: '결제완료',
  cancelled: '취소',
  refunded: '환불',
};

export const ORDER_STATUS_COLORS: Record<POSOrderStatus, string> = {
  draft: 'bg-gray-500',
  paid: 'bg-green-500',
  cancelled: 'bg-red-500',
  refunded: 'bg-yellow-500',
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cash: '현금',
  card: '카드',
  transfer: '계좌이체',
  mixed: '복합결제',
};

// 계산 유틸리티
export function calculateCartTotals(items: CartItem[]): Omit<Cart, 'items'> {
  const subtotal = items.reduce((sum, item) => {
    const itemTotal = item.item.price * item.quantity;
    const itemDiscount = itemTotal * (item.discount / 100);
    return sum + (itemTotal - itemDiscount);
  }, 0);

  const discount = 0; // 전체 할인 (추후 구현)
  const tax = Math.round((subtotal - discount) * 0.1); // 10% 부가세
  const total = subtotal - discount + tax;

  return { subtotal, discount, tax, total };
}

export function generateOrderNo(): string {
  const date = new Date();
  const dateStr = date.toISOString().slice(0, 10).replace(/-/g, '');
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
  return `POS-${dateStr}-${random}`;
}
